import type { CanvasNode, CanvasTool, JsonValue } from "./domain/types";

export function defaultToolProps(tool: CanvasTool): Record<string, JsonValue> {
  if (tool === "arrow") return { color: "#64748b", width: 2, dash: "solid", arrowStart: false, arrowEnd: true };
  return {
    fill: tool === "sticky" ? "#fff2a8" : "#ffffff",
    stroke: tool === "draw" ? "#172033" : "#64748b",
    strokeWidth: tool === "draw" ? 3 : 1.5,
    textColor: "#172033", fontSize: 16, fontFamily: "system-ui", fontWeight: 400,
    fontStyle: "normal", align: ["rectangle", "ellipse", "diamond"].includes(tool) ? "center" : "left",
    strokeStyle: "solid", radius: 10,
  };
}

export function canvasTextStyle(node: Pick<CanvasNode, "props" | "type">) {
  const { props } = node;
  return {
    fontWeight: props.fontWeight === 700 ? 700 : 400,
    fontStyle: props.fontStyle === "italic" ? "italic" as const : "normal" as const,
    textAlign: props.align === "right" ? "right" as const : props.align === "center" || (props.align === undefined && node.type === "shape") ? "center" as const : "left" as const,
  };
}
